export default "__VITE_PUBLIC_ASSET__7ed591fc__"